export const getBase64String = value => {
	return value.substring(value.indexOf(',') + 1);
};
